import service from "@/store/services/ciudades-service";

const state = {
  list: {},
  ciudad: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, ciudad) => {
    state.ciudad = ciudad;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  listTimezone({ commit, dispatch }, params) {
    return service.listTimezone(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then(role => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then(ciudad => {
      commit("SET_RESOURCE", ciudad);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then(ciudad => {
      commit("SET_RESOURCE", ciudad);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  }
};

const getters = {
  list: state => state.list,
  listTimezone: state => state.list,
  listTotal: state => state.meta.total,
  ciudad: state => state.ciudad,
  dropdown: state => {
    return state.list.map(ciudad => ({
      id: ciudad.id,
      nombre: ciudad.nombre,
      abreviatura: ciudad.abreviatura
    }));
  }
};

const ciudades = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default ciudades;
